import { gql } from '@apollo/client/core';

export const FETCH_ACCOUNT_DATA = gql`
  query viewer($kind: AccountKind) {
    viewer(kind: $kind) {
      id
      firstName
      lastName
      email
      photoUrl
      location {
        cityname
        stateabbr
        zipcode
        geoPoint {
          x
          y
        }
      }
      hasPremiumHistory
      profilePhotoStatus
      ... on Parent {
        createdAt
        careType
      }
      ... on Sitter {
        createdAt
        providerType
      }
    }
  }
`;

export const FETCH_PARENT_REGISTRATION = gql`
  query {
    parentRegistration {
      createdAt
      careType
      postalAddress {
        addressLine1
        addressLine2
        city
        stateCode
        postalCode
      }
    }
  }
`;

export const FETCH_ADVENTURE_DATA = gql`
  query ($longitude: Decimal!, $latitude: Decimal!) {
    adventureSearch(first: 3, searchParams: { geoPoint: { x: $longitude, y: $latitude } }) {
      edges {
        cursor
        node {
          adventure {
            id
            adventureCategoryImage {
              url
            }
            title
            ageRangeText
            adventureCategoryName
            minPayRate
            maxPayRate
            sitterLocation {
              cityname
              stateabbr
            }
          }
        }
      }
    }
  }
`;

export const FETCH_SEEKER_DASHBOARD_DATA_QUERY = gql`
  query ($geoPointX: Decimal!, $geoPointY: Decimal!) {
    sitterSearch(first: 3, searchParams: { careType: "babysitter", geoPoint: { x: $geoPointX, y: $geoPointY } }) {
      edges {
        cursor
        node {
          sitter {
            id
            name
            photoUrl
          }
          avgRating
          totalRatings
          yearsExperience
          minRate
          maxRate
        }
      }
    }

    viewer(kind: PARENT) {
      ... on Parent {
        id
        name
        photoUrl
        createdAt
        corpUserGroupInfo {
          url
          name
        }
        excludedFromBhList
        totalReceivedApplications
        jobs(first: 10) {
          edges {
            node {
              id
              careType
              title
              status
              pendingChanges
              parent {
                id
              }
              applications {
                totalCount
              }
              receivedApplications: applications(parentInterestStatus: RECEIVED) {
                totalCount
              }
              createdAt
              updatedAt
              expiresAt
              isActive
              schedule {
                __typename
                ... on OccasionalJobSchedule {
                  startDate
                  isStartDateFlexible
                }
                ... on RegularJobSchedule {
                  startDate
                  isStartDateFlexible
                }
                ... on NannyJobSchedule {
                  startDate
                  isStartDateFlexible
                }
                ... on OneTimeJobSchedule {
                  startDate
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const FETCH_PREVIEW_APPLICATION_SITTERS = gql`
  query ($jobId: UUID!) {
    job(id: $jobId) {
      applications {
        edges {
          node {
            sitter {
              id
              displayName
              lastInitial
              location {
                cityname
                stateabbr
              }
              reviews {
                starAggregate
                totalReviewCount
              }
              badges {
                name
                status
                completedAt
                expiresAt
              }
              idv {
                latestUpdate
                provider
                status
                verdict
              }
              sitterPhotoUrl
              yearsExperience
            }
          }
        }
      }
    }
  }
`;

export const FETCH_JOB_COUNTS = gql`
  query FetchJobCounts {
    viewer(kind: PARENT) {
      ... on Parent {
        openJobs: jobs(first: 0, jobStatuses: [OPEN, PENDING]) {
          totalCount
        }
        closedJobs: jobs(first: 0, jobStatuses: [CLOSED, EXPIRED]) {
          totalCount
        }
      }
    }
  }
`;

export const FETCH_OPEN_JOBS = gql`
  query FetchOpenJobs($after: String) {
    viewer(kind: PARENT) {
      ... on Parent {
        id
        jobs(first: 10, jobStatuses: [OPEN, PENDING], after: $after) {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            cursor
            node {
              id
              careType
              title
              status
              pendingChanges
              parent {
                id
              }
              applications {
                totalCount
              }
              receivedApplications: applications(parentInterestStatus: RECEIVED) {
                totalCount
              }
              createdAt
              updatedAt
              expiresAt
              isActive
              schedule {
                __typename
                ... on OccasionalJobSchedule {
                  startDate
                  isStartDateFlexible
                }
                ... on RegularJobSchedule {
                  startDate
                  isStartDateFlexible
                }
                ... on NannyJobSchedule {
                  startDate
                  isStartDateFlexible
                }
                ... on OneTimeJobSchedule {
                  startDate
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const FETCH_CLOSED_JOBS = gql`
  query FetchClosedJobs($after: String) {
    viewer(kind: PARENT) {
      ... on Parent {
        id
        jobs(first: 10, jobStatuses: [CLOSED, EXPIRED], after: $after) {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            cursor
            node {
              id
              careType
              title
              status
              parent {
                id
              }
              applications {
                totalCount
              }
              receivedApplications: applications(parentInterestStatus: RECEIVED) {
                totalCount
              }
              createdAt
              updatedAt
              expiresAt
              isActive
              schedule {
                __typename
                ... on OccasionalJobSchedule {
                  startDate
                  isStartDateFlexible
                }
                ... on RegularJobSchedule {
                  startDate
                  isStartDateFlexible
                }
                ... on NannyJobSchedule {
                  startDate
                  isStartDateFlexible
                }
                ... on OneTimeJobSchedule {
                  startDate
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default FETCH_SEEKER_DASHBOARD_DATA_QUERY;
